import React from "react";
import "../App.css";

export default function TS400() {
  return (
    <div className="page-in-development" id="ts400">
      <h4>This page is currently in development</h4>
    </div>
  );
}
